export default "__VITE_ASSET__BAjdH96D__"